{
  "$schema": "https://cogo.xyz/ontology/v4/expression-prefix",
  "version": "1.0.0",
  "description": "Canonical-9 expression prefix enum (Wave 10D 2026-04-24). AUTO-GENERATED from cogo-kg-browser/fixtures/expression-prefix-v1.ttl (SOT) by cogo-kg-browser/scripts/generate-expression-prefix-json.ts. DO NOT EDIT BY HAND. Legacy prefixes (state, localState, response, ui, params, page) accepted by runtime alias layer (COGO_RUNTIME_LEGACY_PREFIX_ALIASES default ON) but REJECTED by validator and this schema. Future slot `i18n.` reserved (Wave 11D Q-D4 DEFERRED).",
  "prefixes": [
    {
      "name": "local",
      "semantics": "Component-local state (per-block)",
      "storage": "Block-local state bucket (local.X key)"
    },
    {
      "name": "event",
      "semantics": "Event payload from UI event binding",
      "storage": "Ephemeral, flow-scoped"
    },
    {
      "name": "props",
      "semantics": "External inputs from parent block or page",
      "storage": "External inputs bucket (props.X key)",
      "readOnly": true
    },
    {
      "name": "item",
      "semantics": "Current item in iterateOver iteration context",
      "storage": "Ephemeral, iterator-scoped"
    },
    {
      "name": "_results",
      "semantics": "Named result of a prior ActionFlow step",
      "storage": "Ephemeral, flow-scoped"
    },
    {
      "name": "computed",
      "semantics": "Derived/reactive values recomputed from dependencies",
      "storage": "Recomputed on state change"
    },
    {
      "name": "appData",
      "semantics": "App-wide shared state. Read-mostly from any block; mutations through dedicated actions.",
      "storage": "Global app state bucket (appData.<key>)"
    },
    {
      "name": "env",
      "semantics": "Build-time and runtime configuration (e.g. API base URL, feature flags). Read-only.",
      "storage": "Environment config bucket (env.<key>)",
      "readOnly": true
    },
    {
      "name": "route",
      "semantics": "Current routing context (path, query, params, hash). Read-only; injected by router.",
      "storage": "Router context bucket (route.params.<key>, route.path, etc.)",
      "readOnly": true
    }
  ]
}
